/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Organizeraboutempty2Inputs */

const en_organizeraboutempty2 = /** @type {(inputs: Organizeraboutempty2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Say in two or three sentences who you are and what people can expect.`)
};

const de_organizeraboutempty2 = /** @type {(inputs: Organizeraboutempty2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erzähl in zwei, drei Sätzen, wer du bist und was man bei dir erleben kann.`)
};

/**
* | output |
* | --- |
* | "Say in two or three sentences who you are and what people can expect." |
*
* @param {Organizeraboutempty2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const organizeraboutempty2 = /** @type {((inputs?: Organizeraboutempty2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Organizeraboutempty2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_organizeraboutempty2(inputs)
	return de_organizeraboutempty2(inputs)
});
export { organizeraboutempty2 as "organizerAboutEmpty" }